export const SET_TRANSLATION = "set_translation";
